<template>
    <div class="view contact">
		<div class="view-title">
			<div class="collection">
				<router-link to="/" v-if="isMobile" class="back">
					<button class="btn"><i class="ic ic-chevron-left"></i></button>
					<img src="@/assets/images/bps_logo_store.svg" alt="Merch Store">
				</router-link>
				<span>2019 - 2020<br>Black Pug Studio Collection</span>
			</div>
			<h1>Contact</h1>
			<h3 v-if="isMobile">Contact</h3>
		</div>
		<div class="copy">
			<dl class="board">
				<div class="detail detail-email">
					<dt>Email</dt>
					<dd>
						<a class="email" href="mailto:contact@blackpugstudio.com">contact@blackpugstudio.com</a>
					</dd>
				</div>
				<div class="detail detail-address">
					<dt>Address</dt>
					<dd>
						<address>
							<span class="place">Black Pug Studio</span>
							<span class="lines">18 Platform 94<br>Mervue Business &amp; Technology Park<br>Wellpark Road<br>Galway H91 WT72</span>
						</address>
					</dd>
				</div>
			</dl>
		</div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
	name: "contact",
	computed: {
		...mapGetters({
			isMobile: 'getMobile'
		})
	},
	mounted() {
		window.dispatchEvent(new CustomEvent('setLoading', {detail: {value: false}}))
	}
}
</script>

<style scoped>
.view {
	flex: 1 0 auto;
	display: flex;
	flex-direction: column;
	width: 100%;
}

.copy {
	position: relative;
	z-index: 3;
	display: flex;
	justify-content: center;
	margin-top: 3.6vh;
	padding: 0 2.4vw 1.6vh;
}

.board {
	position: relative;
	display: flex;
	align-items: stretch;
	width: 100%;
	max-width: 860px;
	margin: 0;
	overflow: hidden;
}

.board:before,
.board:after {
	content: '';
	position: absolute;
	border: 2px solid #208E7F;
	pointer-events: none;
}

.board:before {
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 1;
}

.board:after {
	z-index: 1;
	width: 64px;
	height: 64px;
	right: -33px;
	bottom: -33px;
	background: #221F1F;
	transform: rotate(45deg);
}

.detail {
	position: relative;
	z-index: 2;
	flex: 1 1 0;
	min-width: 0;
	padding: 3.1vh 1.8vw 3.5vh;
	font-family: 'Inter', Helvetica, Arial, sans-serif;
}

.detail-email {
	flex: 1.05 1 0;
}

.detail-address {
	flex: 1.2 1 0;
	border-left: 2px solid #208E7F;
	padding-right: 2.6vw;
	padding-bottom: 4.2vh;
}

.board dt,
.board dd {
	margin: 0;
	padding: 0;
}

.board dt {
	margin-bottom: max(12px, 1.35vh);
	color: #249E8E;
	font-family: 'Inter', Helvetica, Arial, sans-serif;
	font-size: 12px;
	font-weight: 500;
	letter-spacing: 0.08em;
	line-height: 1.2;
	text-transform: uppercase;
}

.email {
	display: inline-block;
	max-width: 100%;
	padding: 2px 0;
	color: #EDBA52;
	white-space: nowrap;
	font-size: max(20px, 2.15vh);
	font-weight: 600;
	line-height: 1.35;
	overflow-wrap: break-word;
	text-decoration-line: underline;
	text-decoration-color: rgba(237, 186, 82, 0.45);
	text-decoration-thickness: 1px;
	text-underline-offset: 0.22em;
	transition: text-decoration-color .16s ease-out, color .16s ease-out;
}

.email:hover,
.email:focus-visible {
	color: #F3D48A;
	text-decoration-color: currentColor;
}

.email:focus {
	outline: 2px solid #FAFAFA;
	outline-offset: 4px;
}

.email:focus:not(:focus-visible) {
	outline: none;
}

address {
	margin: 0;
	color: #fff;
	font-style: normal;
	font-size: max(16px, 1.75vh);
	line-height: 1.5;
}

.place {
	display: block;
	margin-bottom: 0.4em;
	font-weight: 600;
}

.lines {
	display: block;
	opacity: 0.77;
}

@media screen and (max-width: 1023px) {
	.view {
		display: flex;
		flex-direction: column;
		flex: 1 0 auto;
		height: auto;
	}

	.copy {
		display: flex;
		justify-content: center;
		margin: 112px 0 8px;
		padding: 0 32px 16px;
	}

	.board {
		max-width: none;
	}

	.board:after {
		width: 52px;
		height: 52px;
		right: -27px;
		bottom: -27px;
	}

	.detail {
		padding: 26px 24px 28px;
	}

	.detail-email {
		flex: 1.08 1 0;
	}

	.detail-address {
		flex: 1 1 0;
		padding-right: 32px;
		padding-bottom: 36px;
	}

	.board dt {
		margin-bottom: 12px;
		font-size: 12px;
	}

	.email {
		padding: 12px 0;
		font-size: 18px;
	}

	address {
		font-size: 16px;
		line-height: 1.5;
	}
}

@media screen and (max-width: 760px) {
	.board {
		flex-direction: column;
	}

	.detail-email,
	.detail-address {
		flex: none;
	}

	.detail-address {
		border-left: 0;
		border-top: 2px solid #208E7F;
	}

	.email {
		font-size: 17px;
		white-space: normal;
	}

	address {
		font-size: 15px;
	}
}

@media screen and (max-width: 410px) {
	.copy {
		margin-top: 104px;
		padding: 0 24px 12px;
	}

	.detail {
		padding: 20px 18px 22px;
	}

	.detail-address {
		padding-right: 28px;
		padding-bottom: 32px;
	}

	.board dt {
		margin-bottom: 8px;
		font-size: 11px;
	}

	.email {
		font-size: 16px;
	}

	address {
		font-size: 14px;
	}
}
</style>
